import { paygEndpoints } from '@/src/constants/endpoints';
import { apiService } from '@/src/services/api-service';
import { useAccountContext } from '@ovotech/ui-tools';
import { useQuery, UseQueryOptions } from 'react-query';
import { paygQueryKeys } from './queryKeys';
import { TopupConfig } from './types';

type Params = Omit<
  UseQueryOptions<
    TopupConfig,
    unknown,
    TopupConfig,
    ReturnType<typeof paygQueryKeys.config>
  >,
  'queryKey' | 'queryFn'
>;

// How long a cached config counts as fresh. `useSupportBanner` polls on the
// same window, so a second reader on the page uses the cache instead of firing
// its own refetch on top of the poll.
export const TOPUP_CONFIG_REFETCH_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

export const useTopupConfig = ({ enabled = true, ...options }: Params = {}) => {
  const { accountId } = useAccountContext();

  return useQuery({
    retry: 1,
    staleTime: TOPUP_CONFIG_REFETCH_INTERVAL_MS,
    ...options,
    enabled: enabled && !!accountId,
    queryKey: paygQueryKeys.config(accountId || ''),
    queryFn: () =>
      apiService.get<TopupConfig>({
        url: paygEndpoints.config(accountId!),
      }),
  });
};
